<template>
  <transition name="slide-fade" mode="out-in">
    <div v-if="showSearch" class="search-bar">
      <input
          type="text"
          @input="performSearch"
          v-model="query"
          placeholder="Введите для поиска..."
          class="search-input text-TTDrugs-bold-18 color-dark"
      />
      <transition name="slide-fade" mode="out-in">
        <ul v-if="results.length" key="results" class="search-results search-results--scrollable">
          <li v-for="result in results" :key="result.key" class="result-item">
            <router-link :to="result.path" @click.native="closeSearch" class="result-link">
              {{ result.meta.title }}
            <p class="result-description">{{ result.meta.description }}</p>
            </router-link>
          </li>
        </ul>
      </transition>
      <transition name="slide-fade" mode="out-in">
        <div class="search-results" v-if="query && !results.length">
        <p key="no-results" class="no-results color-dark">Результаты не найдены</p>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
  import { mapState } from "vuex";
  import { performSiteSearch } from "@/utils/siteSearch";
  import { actionTypesPaid } from "@/store/modules/paidServices";
  import { actionTypesNews } from "@/store/modules/news";
  import { actionTypesDepartment } from "@/store/modules/department";
  import { actionTypes as actionTypesPages } from "@/store/modules/pages";

  export default {
    name: "AppSearch",
    props: {
      showSearch: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        query: "",
        results: []
      };
    },
    computed: {
      ...mapState({
        paidServices: (state) => state.paidServices.paid,
        news: (state) => state.news.news,
        employees: (state) => state.department.EMPLOYEES,
        managements: (state) => state.department.MANAGEMENTS,
        chiefMedicalOfficer: (state) => state.department.CHIEF_MEDICAL_OFFICER,
        publishedPages: (state) => state.pages.menuItems
      })
    },
    methods: {
      closeSearch() {
        this.$emit("close-search");
      },
      performSearch() {
        this.results = performSiteSearch(this.query, {
          paidServices: this.paidServices,
          publishedPages: this.publishedPages,
          news: this.news,
          employees: this.employees,
          managements: this.managements,
          chiefMedicalOfficer: this.chiefMedicalOfficer,
        });
      }
    },
    mounted() {
      if (!this.paidServices || !this.paidServices.length) {
        this.$store.dispatch(actionTypesPaid.getPaid).catch(() => {});
      }
      if (!this.news || !this.news.length) {
        this.$store.dispatch(actionTypesNews.getNews).catch(() => {});
      }
      if ((!this.employees || !this.employees.length) && (!this.managements || !this.managements.length) && (!this.chiefMedicalOfficer || !this.chiefMedicalOfficer.length)) {
        this.$store.dispatch(actionTypesDepartment.getAllDoctors).catch(() => {});
      }
      if (!this.publishedPages || !this.publishedPages.length) {
        this.$store.dispatch(`pages/${actionTypesPages.getPages}`).catch(() => {});
      }
    }
  };
</script>

<style>

/* Анимация появления и исчезновения */
.slide-fade-enter-active, .slide-fade-leave-active {
  transition: opacity 0.5s, transform 0.5s;
}
.slide-fade-enter, .slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
